import React, { useState } from 'react';
import { IAgent } from '../../constants/new-agent/new-agent-form';
import { useTranslation } from 'react-i18next';
import { StatusBadge } from '../status/StatusBadge';
import clsx from 'clsx';
import { toAbsoluteUrl } from '../../utils';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { sentAgentInvite } from '../../store/merchnts/actions/agents';

interface Props extends IAgent {
	onEdit?: (agent: IAgent) => void;
}

export const AgentsTableRow = (props: Props): React.ReactElement => {
	const { onEdit, ...agent } = props;
	const { id, contact } = agent;
	const { t } = useTranslation();

	const [loading, setLoading] = useState<boolean>(false);

	const handleClick = async (): Promise<void> => {
		setLoading(true);
		await sentAgentInvite(id);
		setLoading(false);
	};

	return (
		<tr>
			{/*<td className="id-width cursor-pointer" onClick={(): void => history.push(`${pathname}/${id}`)}>*/}
			{/*	<WhisperComponent*/}
			{/*		whisperText={id}*/}
			{/*		mainText={id}*/}
			{/*		placement="autoVertical"*/}
			{/*		additionalClass="d-block fw-bolder fs-6 text-truncate w-100 mt-2"*/}
			{/*	/>*/}
			{/*</td>*/}
			<td>
				<div className="fs-6 fw-bolder">
					{contact?.firstName} {contact?.lastName}
				</div>
			</td>
			<td>
				<div className="fs-6">
					{contact?.role}
				</div>
			</td>
			<td>
				<div className="fs-6">
					{contact?.email}
				</div>
			</td>
			<td>
				<div className="fs-6">
					{contact?.phone}
				</div>
			</td>
			<td>
				<StatusBadge
					status={contact?.userActive ? t('PARTNERS.STATUS_ACTIVE') : t('PARTNERS.STATUS_PENDING')}
					additionalClasses={clsx(!contact?.userActive && 'text-dark')}
				/>
			</td>
			<td>
				<div className="d-flex">
					<div
						className="d-flex align-items-center cursor-pointer"
						onClick={(): void => onEdit(agent)}
					>
						<img
							src={toAbsoluteUrl('/media/icons/edit-icon.svg')}
							height={16}
							width={16}
							alt="edit-icon"
						/>
						<span className="text-muted fs-7 fw-bolder ms-2" style={{ lineHeight: '20px' }}>
							Edit
						</span>
					</div>
					{
						!contact?.userActive && (
							<ButtonComponent
								buttonName={t('PARTNERS.INVITE_BTN_NAME')}
								buttonType={BUTTON_TYPE.WHITE}
								onButtonClick={handleClick}
								loading={loading}
								additionalClass="invite-btn-width ms-5"
							/>
						)
					}
				</div>
			</td>

		</tr>
	);
};
